import { createBlock } from './createBlock';

// Compatible with older versions
export const createCustomBlock = createBlock;
